import { TabContext } from '@mui/lab';
import {
  Box,
  Button,
  Grid,
  Stack,
  Tab,
  Tabs,
  Link,
  Chip,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';
import { DataGridProProps, GridActionsCellItem, GridToolbarExport } from '@mui/x-data-grid-pro';
import AddIcon from '@mui/icons-material/Add';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import CRFBasePopup from '../CRFForms/CRFBasePopup';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { openCRFModel } from 'src/store/CrfFormsAction';
import { useTrailNotebookCRF } from './useTrailNotebookCRF';
import { useCRFForms } from '../CRFForms/useCRFForms';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useGetAssigneesMutation } from 'src/services/Utils';
import staticData from '../../../resources/static.json';
import Loader from '../../common/Loader';
import AuditTrailContent from '../SubjectTracking/PrescreenDetails/AuditTrailLayout';
import './AuditTrailStyles.scss';
import CustomSelect from './CustomDropdown';
import { useUtil } from 'src/components/hooks/useUtil';
import { DataTable } from '@pihealth/common-ui-library';

const CRFSTab: React.FC<any> = ({ parent_id }) => {
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const user = useAppSelector(state => `${state.user.user?.firstName} ${state.user.user?.lastName}`);

  const isOpenCRFModel = useAppSelector(state => state.CRFForms.isOpenCRFModel);
  const { checkPermission } = usePermissionWrapper();

  const [isUpdate, setisUpdate] = useState(false);

  const { userPreferedDateFormat } = usePreferedDateFormat();

  const getTreeDataPath: DataGridProProps['getTreeDataPath'] = row => row.hierarchy;
  const groupingColDef: DataGridProProps['groupingColDef'] = {
    headerName: 'Event Number',
    minWidth: 100,
    flex: 1
  };

  const dispatch = useAppDispatch();

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    dispatch(openCRFModel(true));
    setAnchorEl(null);
    setisAddCliked(true);
    setisAddMode(true);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [selectedVisit, setselectedVisit] = useState<any>(null);
  const [isAddCliked, setisAddCliked] = useState<any>(false);
  const [isAddMode, setisAddMode] = useState<any>(false);

  const {
    getVisitsAndCRFOIDs,
    getVisitsAndCRFOIDsData,
    getPatientsDetails,
    getPatientsDetailsData,
    getPatientsDetailsError,
    getPatientsDetailsIsError,
    getPatientsDetailsIsLoading,
    deleteCRFEvent,
    deleteCRFEventData,
    deleteCRFEventIsError,
    deleteCRFEventIsSuccess,
    /** CTMSKANBAN-5655-5598 Start */
    getAllPatientVisits,
    getAllPatientVisitsData,
    getAllPatientVisitsIsSuccess,
    getAllPatientVisitsIsLoading,
    startPatientVisit,
    startPatientVisitIsError,
    startPatientVisitIsSuccess,
    startPatientVisitIsLoading,
    startPatientVisitError,
    getStartPatientVisitStatus,
    getStartPatientVisitStatusData,
    getStartPatientVisitStatusIsSuccess,
    getStartPatientVisitStatusIsLoading,
    getVisitSpecificCRFs,
    getVisitSpecificCRFsData,
    getVisitSpecificCRFsIsError,
    getVisitSpecificCRFsIsSuccess,
    getVisitSpecificCRFsIsLoading,
    getVisitSpecificCRFsError
    /** CTMSKANBAN-5655-5598 End */
  } = useTrailNotebookCRF();

  const { selectCRFDataByID, selectCRFDataByIDData, selectCRFDataByIDIsLoading, selectCRFDataByIDIsSuccess } =
    useCRFForms();

  useEffect(() => {
    getVisitsAndCRFOIDs({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry
    });
  }, []);

  const [visitCRFOIDs, setvisitCRFOIDs] = useState<any>([]);
  const [selectedFormOID, setselectedFormOID] = useState<any>(null);
  const [crfVisitList, setcrfVisitList] = useState<any>([]);
  const [crfFormMetaData, setcrfFormMetaData] = useState<any>(null);
  const [crfFormMetaDataFields, setcrfFormMetaDataFields] = useState<any>(null);
  const [crfForomColumns, setcrfForomColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const selectedSubjectInfo = useAppSelector(state => state.selectedSubjectInfo);

  const handleChangeOIDTabs = (_: any, newValue: any) => {
    setselectedFormOID(newValue);
  };

  useEffect(() => {
    if (visitCRFOIDs.length > 0 && selectedSubjectInfo.selected_crf) {
      setselectedFormOID(selectedSubjectInfo.selected_crf);
    } else if (visitCRFOIDs.length > 0) {
      setselectedFormOID(visitCRFOIDs[0].OID);
    }
  }, [visitCRFOIDs]);
  const bindRowData = (patientsDetailsData: any) => {
    if (patientsDetailsData.length > 0) {
      setcrfFormMetaDataFields(patientsDetailsData[0].visit_crf);
      setcrfFormMetaData(patientsDetailsData[0].visit_crf);
    }
    const rows: any = [];
    const addedRow: any = [];
    const dataIds: any = [];
    patientsDetailsData?.map((visit: any) => {
      if (
        visit.crf_data.length > 0 &&
        visit?.visit_appointment?.is_visit_started == 'in_progress' &&
        visit?.visit_appointment?.appointment_id
      ) {
        visit.crf_data?.map((data: any) => {
          if (!dataIds.includes(data.result.id)) {
            dataIds.push(data.result.id);
            const renderingData = data.result;
            const formData = visit.visit_crf.meta.sections.flatMap((section: any) =>
              section.rows.flatMap((row: any) => row.fields)
            );
            let tempdata = {};
            formData?.map((field: any) => {
              if (
                field?.cmp == 'checkbox' &&
                field?.data_dictionary_values &&
                field?.data_dictionary_values.length > 0
              ) {
                if (renderingData[field.key] != null) {
                  const valUesKeys = Object.keys(renderingData[field.key]);
                  const checkBoxValues: any = [];
                  if (valUesKeys?.length) {
                    valUesKeys?.map((item: any) => {
                      if (renderingData[field.key][item]) {
                        for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                          if (item == field?.data_dictionary_values[i].code_list_value_code) {
                            checkBoxValues.push(field?.data_dictionary_values[i].code_list_value);
                            break;
                          }
                        }
                      }
                    });
                  }
                  tempdata = { ...tempdata, [field.key]: checkBoxValues.toString() };
                }
              } else if (
                field?.cmp == 'select' &&
                field?.data_dictionary_values &&
                field?.data_dictionary_values.length > 0
              ) {
                if (field?.multiple && renderingData[field.key] != null) {
                  const multipleValueData = renderingData[field.key].key;
                  const ddmValues: any = [];
                  if (multipleValueData?.length) {
                    multipleValueData?.map((item: any) => {
                      for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                        if (
                          item?.value == field?.data_dictionary_values[i].code_list_value_code ||
                          item?.code_list_value_code == field?.data_dictionary_values[i].code_list_value_code
                        ) {
                          ddmValues.push(field?.data_dictionary_values[i].code_list_value);
                          break;
                        }
                      }
                    });
                  }
                  tempdata = { ...tempdata, [field.key]: ddmValues.toString() };
                } else {
                  if (renderingData[field.key] != null) {
                    tempdata = { ...tempdata, [field.key]: renderingData[field.key].label };
                  }
                }
              } else if (
                field?.cmp == 'radio' &&
                field?.data_dictionary_values &&
                field?.data_dictionary_values.length > 0
              ) {
                for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                  if (renderingData[field.key] == field?.data_dictionary_values[i].code_list_value_code) {
                    tempdata = { ...tempdata, [field.key]: field?.data_dictionary_values[i].code_list_value };
                    break;
                  }
                }
              } else if (field?.cmp == 'date' && field?.type == 'date_time' && renderingData[field.key] != null) {
                tempdata = {
                  ...tempdata,
                  [field.key]: moment(renderingData[field.key]).format(`${userPreferedDateFormat.toUpperCase()} h:mm A`)
                };
              } else if (field?.cmp == 'time' && renderingData[field.key] != null) {
                tempdata = {
                  ...tempdata,
                  [field.key]: renderingData[field.key]
                };
              } else if (
                field?.cmp == 'date' &&
                field?.type == 'date' &&
                field?.allow_partial &&
                renderingData[field.key] != null
              ) {
                const day = renderingData[field.key]?.allow_partial_day;
                const month = renderingData[field.key]?.allow_partial_month;
                const year = renderingData[field.key]?.allow_partial_year;
                let partialDate: any;
                if (day && month && year) {
                  const tempDate = userPreferedDateFormat.toUpperCase().replace('DD', day).replace('YYYY', year);
                  if (userPreferedDateFormat.toUpperCase().includes('MMM')) {
                    partialDate = tempDate.replace('MMM', month);
                  } else {
                    partialDate = tempDate.replace('MM', month);
                  }
                }
                tempdata = {
                  ...tempdata,
                  [field.key]: partialDate
                };
              } else if (field?.cmp == 'date' && field?.type == 'date' && renderingData[field.key] != null) {
                tempdata = {
                  ...tempdata,
                  [field.key]: moment(renderingData[field.key]).format(`${userPreferedDateFormat.toUpperCase()} `)
                };
              }
            });
            if (data.linked_crfs_data.length > 0) {
              const associatedCRFsData: any = [];
              data.linked_crfs_data?.map(async (eventData: any) => {
                if (eventData?.bookmark_key_value && eventData?.bookmark_key) {
                  if (eventData?.bookmark_cmp?.cmp == 'date') {
                    if (eventData?.bookmark_cmp?.type == 'date_time') {
                      associatedCRFsData.push(
                        moment(new Date(eventData.bookmark_key_value)).format(
                          `${userPreferedDateFormat.toUpperCase()} h:mm A`
                        )
                      );
                    } else if (
                      eventData?.bookmark_cmp?.cmp == 'date' &&
                      eventData?.bookmark_cmp?.allow_partial == true &&
                      typeof eventData.bookmark_key_value == 'object'
                    ) {
                      const day = eventData.bookmark_key_value?.allow_partial_day;
                      const month = eventData.bookmark_key_value?.allow_partial_month;
                      const year = eventData.bookmark_key_value?.allow_partial_year;
                      let partialDate: any;
                      if (day && month && year) {
                        const tempDate = userPreferedDateFormat.toUpperCase().replace('DD', day).replace('YYYY', year);
                        if (userPreferedDateFormat.toUpperCase().includes('MMM')) {
                          partialDate = tempDate.replace('MMM', month);
                        } else {
                          partialDate = tempDate.replace('MM', month);
                        }
                        associatedCRFsData.push(partialDate);
                      }
                    } else {
                      associatedCRFsData.push(
                        moment(eventData.bookmark_key_value).format(`${userPreferedDateFormat.toUpperCase()}`)
                      );
                    }
                  } else if (eventData?.bookmark_cmp?.cmp == 'time') {
                    associatedCRFsData.push(eventData.bookmark_key_value);
                  } else if (
                    eventData?.bookmark_cmp?.cmp == 'select' &&
                    eventData?.bookmark_cmp?.multiple &&
                    typeof eventData.bookmark_key_value === 'object' &&
                    'key' in eventData.bookmark_key_value
                  ) {
                    const bookMarkValues = eventData?.bookmark_key_value?.key?.map((value: any) => value.label);
                    associatedCRFsData.push(bookMarkValues.toString());
                  } else if (
                    eventData?.bookmark_cmp?.cmp == 'select' &&
                    typeof eventData.bookmark_key_value === 'object'
                  ) {
                    associatedCRFsData.push(eventData.bookmark_key_value?.label);
                  } else if (eventData?.bookmark_cmp?.cmp == 'checkbox') {
                    let rawData: any = eventData.bookmark_key_value;
                    if (Array.isArray(rawData)) {
                      rawData = rawData.reduce((a, v) => ({ ...a, [v]: true }), {});
                    }
                    const valUesKeys = Object.keys(rawData);
                    const checkBoxValues: any = [];
                    valUesKeys?.map((item: any) => {
                      if (rawData[item]) {
                        for (let i = 0; i < eventData.bookmark_cmp.data_dictionary_values.length; i++) {
                          if (item == eventData.bookmark_cmp?.data_dictionary_values[i].code_list_value_code) {
                            checkBoxValues.push(eventData.bookmark_cmp?.data_dictionary_values[i].code_list_value);
                            break;
                          }
                        }
                      }
                    });
                    associatedCRFsData.push(checkBoxValues.toString());
                  } else if (eventData?.bookmark_cmp?.cmp == 'radio') {
                    const rawData: any = eventData.bookmark_key_value;
                    let returnVal: any = '';
                    if (rawData) {
                      for (let i = 0; i < eventData.bookmark_cmp.data_dictionary_values.length; i++) {
                        if (rawData == eventData.bookmark_cmp?.data_dictionary_values[i].code_list_value_code) {
                          returnVal = `${eventData.bookmark_cmp?.title}-${eventData.bookmark_cmp?.data_dictionary_values[i].code_list_value}`;
                          break;
                        }
                      }
                    }
                    associatedCRFsData.push(returnVal);
                  } else {
                    associatedCRFsData.push(eventData.bookmark_key_value.toString());
                  }
                } else {
                  associatedCRFsData.push(
                    `${eventData.event_number} (${moment(new Date(eventData.date_of_entry)).format(
                      `${userPreferedDateFormat.toUpperCase()}`
                    )})`
                  );
                }
              });
              tempdata = { ...tempdata, associated_crfs: associatedCRFsData };
            } else {
              tempdata = { ...tempdata, associated_crfs: null };
            }
            // const resultData = getCodelistValueFormData(visit.visit_crf.meta, data);
            data = { ...data.result, ...tempdata };
            rows.push({
              hierarchy: [
                `${
                  visit?.unscheduled_visit !== null ? visit?.unscheduled_visit : visit.study_visit.protocol_visit_name
                }${
                  visit.study_visit.visit_date
                    ? `- ${moment(visit.study_visit?.visit_date).format(userPreferedDateFormat.toUpperCase())}`
                    : ''
                }`,
                data.event_number
              ],
              ...data,
              id: data.event_uuid,
              nativeCRFId: data.id
            });
          }
        });
      } else if (visit?.visit_appointment?.is_visit_started == 'in_progress' && visit?.study_visit?.id) {
        if (!addedRow.includes(visit.study_visit.protocol_visit_name)) {
          addedRow.push(
            visit?.unscheduled_visit !== null ? visit?.unscheduled_visit : visit.study_visit.protocol_visit_name
          );
          rows.push({
            hierarchy: [
              `${visit?.unscheduled_visit !== null ? visit?.unscheduled_visit : visit.study_visit.protocol_visit_name}${
                visit.study_visit.visit_date
                  ? `- ${moment(visit.study_visit?.visit_date).format(userPreferedDateFormat.toUpperCase())}`
                  : ''
              }`
            ],
            id: visit?.visit_appointment?.appointment_id
          });
        }
      }
    });
    setcrfVisitList(rows);
  };

  useEffect(() => {
    if (!selectCRFDataByIDIsLoading && selectCRFDataByIDIsSuccess) {
      setcrfFormMetaData(selectCRFDataByIDData[0]?.form_data);
    }
  }, [selectCRFDataByIDIsLoading, selectCRFDataByIDIsSuccess, selectCRFDataByIDData]);

  const [editRowData, seteditRowData] = useState<any>(null);

  useEffect(() => {
    if (editRowData) {
      (async () => {
        dispatch(showLoader());
        if (selectedVisit?.visit_crf?.OID && editRowData) {
          await selectCRFDataByID({
            data: {
              OID: selectedVisit?.visit_crf.OID,
              patient_id: parent_id,
              event_uuid: editRowData?.event_uuid,
              visit_id: editRowData?.visit_id ?? selectedVisit?.study_visit.id,
              creation_source: editRowData?.creation_source ? editRowData?.creation_source : 'TSDA'
            },
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry
          });
        }
        dispatch(hideLoader());
      })();
    }
  }, [editRowData]);

  const editAddedRecord = (editAddedRecord: any) => {
    seteditRowData(editAddedRecord);
    setisUpdate(true);
    setisAddMode(false);
    dispatch(openCRFModel(true));
  };

  const [openDeleteCRFModel, setopenDeleteCRFModel] = useState(false);
  const [currentDeleteCRFEvent, setcurrentDeleteCRFEvent] = useState<any>(null);

  const didDeleteCRFEvent = (row: any) => {
    setcurrentDeleteCRFEvent(row);
    setopenDeleteCRFModel(true);
  };

  const handleCloseDeleteCRFModel = () => {
    setopenDeleteCRFModel(false);
  };
  const handleConfirmDeleteCRFModel = () => {
    dispatch(showLoader());
    setopenDeleteCRFModel(false);
    const findVisit = getPatientsDetailsData?.find(
      (item: any) => item.study_visit.id == currentDeleteCRFEvent.visit_id
    );
    setselectedVisit(findVisit);
    deleteCRFEvent({
      data: {
        patient_id: parent_id,
        visit_id: currentDeleteCRFEvent.visit_id,
        OID: selectedFormOID,
        id: currentDeleteCRFEvent?.nativeCRFId,
        crf_form_version: currentDeleteCRFEvent.crf_form_version,
        updated_by: user
      },
      study_id: studyId,
      site_id: selectedSite,
      country: selectedCountry
    });
  };
  useEffect(() => {
    if (deleteCRFEventIsSuccess && deleteCRFEventData) {
      (async deleteCRFEventData => {
        await getPatientsDetails({
          OID: selectedVisit.visit_crf.OID,
          parent_id,
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry
        });
        setcurrentDeleteCRFEvent(null);
        dispatch(hideLoader());
        const deletedLInksMsg =
          deleteCRFEventData?.removed_linked_oids.length > 0
            ? `Links of the ${deleteCRFEventData?.removed_linked_oids.toString()} is also deleted.`
            : '';
        dispatch(
          setMessage({
            msgDetails: `Event deleted successfully. ${deletedLInksMsg}`,
            severity: 'success'
          })
        );
      })(deleteCRFEventData);
    } else if (deleteCRFEventIsError) {
      dispatch(hideLoader());
      dispatch(
        setMessage({
          msgDetails: 'Error in delete CRF Event.',
          severity: 'error'
        })
      );
    }
  }, [deleteCRFEventIsSuccess, deleteCRFEventData, deleteCRFEventIsError]);

  const [bookMarkKey, setbookMarkKey] = useState<any>(null);
  const [bookMarkField, setbookMarkField] = useState<any>(null);
  const dateOfEntryConversion = (row: any) => {
    return row?.date_of_entry ? moment(row.date_of_entry).format(`${userPreferedDateFormat.toUpperCase()}`) : null;
  };
  useEffect(() => {
    if (crfFormMetaDataFields && crfFormMetaDataFields.meta?.sections) {
      const formData = crfFormMetaDataFields.meta.sections.flatMap((section: any) =>
        section.rows.flatMap((row: any) => row.fields)
      );
      const find = formData?.find((item: any) => item?.bookmark);
      if (find) {
        setbookMarkKey(find.key);
        setbookMarkField(find);
      }
      const preparedColums: any = [
        {
          field: 'date_of_entry',
          type: 'string',
          headerName: 'Date Of Entry',
          minWidth: 100,
          flex: 1,
          renderCell: (params: any) => {
            if (params?.row && !('event_number' in params.row)) {
              return <span className="noParent" />;
            } else if (params?.row?.event_status !== 'Deleted') {
              return (
                <Link
                  onClick={async () => {
                    dispatch(showLoader());
                    if (selectedFormOID && params.row.event_uuid) {
                      await selectCRFDataByID({
                        data: {
                          OID: selectedFormOID,
                          patient_id: parent_id,
                          event_uuid: params.row.event_uuid,
                          visit_id: params.row.visit_id ?? selectedVisit?.study_visit.id,
                          creation_source: params.row?.creation_source ? params.row?.creation_source : 'TSDA'
                        },
                        site_id: selectedSite,
                        study_id: studyId,
                        country: selectedCountry
                      });
                    }
                    dispatch(hideLoader());
                    editAddedRecord(params.row);
                  }}
                >
                  {dateOfEntryConversion(params?.row)}
                </Link>
              );
            } else {
              return <span className="deletedCRFEventRow">{dateOfEntryConversion(params?.row)}</span>;
            }
          },
          valueGetter: (params: any) => {
            if (params?.row && !('event_number' in params.row)) {
              return;
            } else {
              return dateOfEntryConversion(params?.row);
            }
          }
        },
        {
          field: 'event_status',
          type: 'singleSelect',
          headerName: 'Event Status',
          minWidth: 100,
          flex: 1,
          valueOptions: ['Draft', 'Complete', 'Deleted']
        }
      ];

      formData?.map((field: any) => {
        if (field?.key) {
          preparedColums.push({
            field: field?.key,
            type: 'string',
            headerName: field?.title,
            minWidth: 100,
            flex: 1
          });
        }
      });
      preparedColums.push({
        field: 'associated_crfs',
        type: 'string',
        headerName: 'Associated CRFs',
        minWidth: 200,
        flex: 1,
        renderCell: (params: any) => {
          return (
            <Stack direction="column" spacing={0.5}>
              {params?.row?.associated_crfs && params?.row?.associated_crfs.length > 0
                ? params?.row?.associated_crfs?.map((linkedCrf: any) => {
                    return (
                      <Chip
                        key={linkedCrf}
                        size="small"
                        label={linkedCrf}
                        variant="outlined"
                        color="primary"
                        sx={{
                          fontSize: '12px',
                          fontWeight: 700,
                          '@media (max-width:1430px)': {
                            maxWidth: '150px'
                          },
                          '@media (min-width:1431px)': {
                            maxWidth: '170px'
                          }
                        }}
                      />
                    );
                  })
                : null}
            </Stack>
          );
        }
      });
      preparedColums.push({
        field: 'actions',
        type: 'actions',
        width: 80,
        getActions: (params: any) => {
          if (params?.row && 'event_number' in params.row) {
            const deleted = params?.row?.event_status == 'Deleted';
            return [
              <GridActionsCellItem
                disabled={
                  params?.row?.event_status == 'Deleted' ||
                  !checkPermission('delete_crf_event') ||
                  params?.row?.creation_source == 'FICS'
                }
                key={params?.row?.id}
                label="Delete"
                onClick={() => (params?.row?.creation_source == 'FICS' ? undefined : didDeleteCRFEvent(params.row))}
                className={params?.row?.creation_source == 'FICS' && !deleted ? 'crf-delete' : undefined}
                showInMenu
              />,
              <GridActionsCellItem
                key={params?.row?.id}
                label="Audit Trail"
                onClick={() => handleClickOpenAuditTrailCRF(params?.row)}
                showInMenu
              />
            ];
          } else {
            return [];
          }
        }
      });
      setcrfForomColumns(preparedColums);
    }
  }, [crfFormMetaDataFields]);

  // Audit Trail Dialog
  const [openAuditTrailCRF, setopenAuditTrailCRF] = useState<boolean>(false);
  const [selectedCRFData, setSelectedCRFData] = useState<any>({});
  const handleClickOpenAuditTrailCRF = (data: any) => {
    setSelectedCRFData(data);
    setopenAuditTrailCRF(true);
  };

  const handleCloseAuditTrailCRF = () => {
    setopenAuditTrailCRF(false);
  };
  // Audit Trail Dialog call ends
  const [auditUsersList, setAuditUsersList] = useState([]);
  const [
    getAssignees,
    { isLoading: isAssingeeLoading, data: assignees, isError: isAssingeeError, isSuccess: isAssingeeSuccess }
  ] = useGetAssigneesMutation();
  useEffect(() => {
    getAssignees({
      client_name: 'tsda-ui',
      data: ['ADD_CRF_ENTRY', 'DELETE_CRF_EVENT']
    });
  }, []);
  useEffect(() => {
    if (!isAssingeeLoading && isAssingeeError) {
      dispatch(setMessage({ msgDetails: 'Unable to get assignees', severity: 'error' }));
    } else if (!isAssingeeLoading && isAssingeeSuccess && assignees) {
      const assignList: any = assignees?.map((item: any) => `${item.first_name} ${item.last_name}`);
      setAuditUsersList(assignList);
    }
  }, [isAssingeeLoading, isAssingeeSuccess, assignees, isAssingeeError]);

  /** CTMSKANBAN-5655-5598 Start */
  const [visitOptionData, setVisitOptionData] = useState({ upcomingAppointments: [], pastAppointments: [] });
  const [selectedAppointment, setSelectedAppointment] = useState<any>(null);
  const [currentVisitFetchStatus, setcurrentVisitFetchStatus] = useState(0);

  useEffect(() => {
    if (
      getVisitsAndCRFOIDsData &&
      getAllPatientVisitsIsSuccess &&
      !getAllPatientVisitsIsLoading &&
      selectedAppointment == null &&
      !getVisitSpecificCRFsIsLoading
    ) {
      const mockArr: any = [];
      const duplicateArrCheck: any = [];
      getVisitsAndCRFOIDsData?.map((obj: any) => {
        if (!duplicateArrCheck.includes(obj.OID)) {
          mockArr.push(obj);
          duplicateArrCheck.push(obj.OID);
        }
      });
      setvisitCRFOIDs(mockArr);
    }
  }, [
    getVisitsAndCRFOIDsData,
    getAllPatientVisitsIsSuccess,
    getAllPatientVisitsIsLoading,
    selectedAppointment,
    getVisitSpecificCRFsIsLoading
  ]);

  useEffect(() => {
    if (getPatientsDetailsData) {
      bindRowData(getPatientsDetailsData);
      if (selectedAppointment) {
        const temp = getPatientsDetailsData?.find(
          (item: any) => item?.visit_appointment?.appointment_id == selectedAppointment?.study_visit?.appointment_id
        );
        if (temp) {
          setselectedVisit(temp);
        }
      }
    } else {
      setcrfVisitList([]);
      setcrfFormMetaDataFields([]);
      setcrfFormMetaData([]);
    }
  }, [getPatientsDetailsData, selectedAppointment, isAddCliked]);

  useEffect(() => {
    if (getPatientsDetailsData && editRowData) {
      // const findVisit = getPatientsDetailsData.find((item: any) => item.study_visit.id == editRowData.visit_id);
      const findVisit: any = getPatientsDetailsData?.find((item: any) =>
        item?.crf_data?.find((ele: any) => ele.result.event_uuid == editRowData.event_uuid)
      );
      setselectedVisit(findVisit);
    }
  }, [editRowData, getPatientsDetailsData]);

  useEffect(() => {
    (async () => {
      dispatch(showLoader());
      await getAllPatientVisits({
        parent_id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry
      });
      dispatch(hideLoader());
    })();
  }, []);

  useEffect(() => {
    if (getAllPatientVisitsData) {
      const optionSData: any = getAllPatientVisitsData?.map((item: any) => {
        return {
          label: item.visit_name,
          datetime: moment(new Date(item.start_on)).format(`${userPreferedDateFormat.toUpperCase()} h:mm A`),
          study_visit: item
        };
      });
      const [pastAppointments, upcomingAppointments] = optionSData.reduce(
        ([pastAppointments, upcomingAppointments]: any, obj: any) =>
          obj.study_visit.is_visit_started == 'in_progress'
            ? [[...pastAppointments, obj], upcomingAppointments]
            : [pastAppointments, [...upcomingAppointments, obj]],
        [[], []]
      );
      setVisitOptionData({ upcomingAppointments, pastAppointments });
    }
  }, [getAllPatientVisitsData]);

  const handleChangeAppointment = async (visit: any) => {
    setStartStatus(null);
    setselectedFormOID(null);
    if (visit != null) {
      setSelectedAppointment(visit);
      dispatch(showLoader());
      await getVisitSpecificCRFs({
        visit_id: visit?.study_visit?.visit_id,
        visit_name: visit?.study_visit?.visit_name,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        parent_id
      });
      dispatch(hideLoader());
      if (visit.study_visit.is_visit_started == 'in_progress') {
        getStartPatientVisitStatus({
          data: {
            visit_id: visit.study_visit.visit_id,
            patient_id: parent_id,
            appointment_id: visit.study_visit.appointment_id
          },
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry
        });
      }
    } else {
      setSelectedAppointment(null);
      setselectedVisit(null);
      dispatch(showLoader());
      await getVisitsAndCRFOIDs({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry
      });
      dispatch(hideLoader());
    }
  };

  const handleStartvisit = async (visit: any) => {
    if (visit.study_visit.is_visit_started !== 'in_progress') {
      dispatch(showLoader());
      await startPatientVisit({
        data: {
          visit_id: visit.study_visit.visit_id,
          patient_id: parent_id,
          appointment_id: visit.study_visit.appointment_id
        },
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry
      });
      dispatch(hideLoader());
      getStartPatientVisitStatus({
        data: {
          visit_id: visit.study_visit.visit_id,
          patient_id: parent_id,
          appointment_id: visit.study_visit.appointment_id
        },
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry
      });
    }
  };
  useEffect(() => {
    if (!getStartPatientVisitStatusIsLoading && getStartPatientVisitStatusIsSuccess && getStartPatientVisitStatusData) {
      setcurrentVisitFetchStatus(getStartPatientVisitStatusData.percentage_completion);
    }
  }, [getStartPatientVisitStatusData, getStartPatientVisitStatusIsSuccess, getStartPatientVisitStatusIsLoading]);
  const { handleError } = useUtil();
  useEffect(() => {
    if (
      getVisitSpecificCRFsData &&
      !getVisitSpecificCRFsIsLoading &&
      getVisitSpecificCRFsIsSuccess &&
      selectedAppointment
    ) {
      const mockArr: any = [];
      const duplicateArrCheck: any = [];
      getVisitSpecificCRFsData?.map((obj: any) => {
        if (!duplicateArrCheck.includes(obj.OID)) {
          mockArr.push({ OID: obj.visit_crf.OID, custom_name: obj.visit_crf.custom_name });
          duplicateArrCheck.push({ OID: obj.visit_crf.OID });
        }
      });
      setvisitCRFOIDs(mockArr);
    } else if (!getVisitSpecificCRFsIsLoading && getVisitSpecificCRFsIsError && getVisitSpecificCRFsError) {
      const errorData: any = getVisitSpecificCRFsError;
      handleError(errorData);
      setvisitCRFOIDs([]);
      setselectedVisit(null);
      setcrfVisitList([]);
      setcrfFormMetaData(null);
    }
  }, [
    getVisitSpecificCRFsData,
    getVisitSpecificCRFsIsError,
    getVisitSpecificCRFsIsSuccess,
    getVisitSpecificCRFsIsLoading,
    getVisitSpecificCRFsError,
    selectedAppointment
  ]);

  const [startStatus, setStartStatus] = useState<any>(null);
  useEffect(() => {
    if (!startPatientVisitIsLoading && startPatientVisitIsSuccess) {
      (async () => {
        dispatch(showLoader());
        await getAllPatientVisits({
          parent_id,
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry
        });
        dispatch(hideLoader());
      })();
      dispatch(
        setMessage({
          msgDetails: 'Visit Started Successfully',
          severity: 'success'
        })
      );
      setStartStatus(true);
    } else if (!startPatientVisitIsLoading && startPatientVisitError && startPatientVisitIsError) {
      const errorData: any = startPatientVisitError;
      handleError(errorData);
    }
  }, [startPatientVisitIsError, startPatientVisitIsSuccess, startPatientVisitIsLoading, startPatientVisitError]);

  useEffect(() => {
    if (selectedFormOID) {
      (async () => {
        dispatch(showLoader());
        await getPatientsDetails({
          OID: selectedFormOID,
          parent_id,
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry
        });
        dispatch(hideLoader());
      })();
    }
  }, [selectedFormOID, isUpdate, isOpenCRFModel, startStatus]);

  useEffect(() => {
    if (getPatientsDetailsIsError && getPatientsDetailsError) {
      const errorData: any = getPatientsDetailsError;
      handleError(errorData, true);
      setcrfVisitList([]);
      setcrfFormMetaDataFields(null);
      setcrfFormMetaData(null);
      setcrfForomColumns([]);
    }
  }, [getPatientsDetailsError, getPatientsDetailsIsError]);

  useEffect(() => {
    if (getPatientsDetailsIsLoading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [getPatientsDetailsIsLoading]);

  /**
   * CTMSKANBAN-6434
   * This useEffect is for resetting selectedVisit, when it is null based on selected selectedAppointment start
   */
  useEffect(() => {
    if (selectedVisit == null && selectedAppointment != null && getPatientsDetailsData) {
      const temp = getPatientsDetailsData?.find(
        (item: any) => item?.visit_appointment?.appointment_id == selectedAppointment?.study_visit?.appointment_id
      );
      if (temp) {
        setselectedVisit(temp);
      }
    } else if (selectedVisit == null && selectedAppointment == null) {
      setselectedVisit(null);
    }
  }, [selectedVisit]);

  /**
   * CTMSKANBAN-6434
   * End
   */

  /** CTMSKANBAN-5655-5598 End */
  const dataTableProps = {
    treeData: true,
    getTreeDataPath,
    getRowHeight: () => 'auto',
    getEstimatedRowHeight: () => 200,
    groupingColDef,
    defaultGroupingExpansionDepth: 1,
    sx: {
      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '18px' }
    },
    localeText: { footerTotalRows: 'Total Row(s):' }
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `Conduct CRF Summary ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  return (
    <div>
      <Loader />
      <Box sx={{ mt: 2, mb: 2 }}>
        <CustomSelect
          visitOptionData={visitOptionData}
          selectedAppointment={selectedAppointment}
          setSelectedAppointment={setSelectedAppointment}
          handleChange={handleChangeAppointment}
          handleStartVisit={handleStartvisit}
          currentVisitFetchStatus={currentVisitFetchStatus}
          startStatus={startStatus}
        />
      </Box>

      <TabContext value={selectedFormOID}>
        <Tabs
          onChange={handleChangeOIDTabs}
          aria-label="Form OID Tabs"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          className="mhTabs"
          sx={{ mt: 1, height: 36 }}
          value={selectedFormOID}
        >
          {visitCRFOIDs?.map((ele: any) => (
            <Tab
              iconPosition="end"
              style={{ height: '36px', minHeight: '36px' }}
              label={ele.custom_name ?? ele.OID}
              value={ele.OID}
              key={ele.OID}
            />
          ))}
        </Tabs>
      </TabContext>

      <Box sx={{ flexGrow: 1 }} mt={1}>
        <Grid container col-md-12>
          <Grid item col-md-6>
            <h3 style={{ margin: '0.5rem 0 1.5rem' }}>
              {crfFormMetaDataFields?.custom_name ?? crfFormMetaDataFields?.meta?.title}
            </h3>
          </Grid>
          <Grid item sm sx={{ textAlign: 'end' }} col-md-6>
            {/* <Button sx={{ marginRight: '8px' }} variant="outlined" disabled onClick={editEventsInVisit}>
              EDIT EVENTS IN THE APPOINTMENT
            </Button> */}
            <Button
              aria-describedby={id}
              variant="outlined"
              disabled={
                !checkPermission('add_crf_entry') ||
                selectedAppointment == null ||
                selectedVisit?.visit_appointment?.is_visit_started !== 'in_progress'
              }
              onClick={handleClick}
              startIcon={<AddIcon />}
            >
              ADD EVENTS IN THE APPOINTMENT
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          height: '68vh',
          width: '100%',
          mt: 1
        }}
      >
        <DataTable
          dataTableProps={dataTableProps}
          rows={crfVisitList}
          hasDefinedColumns
          columns={crfForomColumns}
          disableSelectionOnClick
          pinnedColumns={{
            right: ['actions']
          }}
          hasDefinedDataGridToolbarExport
          definedGridToolbarExport={definedCustomDatGridExport}
          height={'68vh'}
          pagination={false}
        />
      </Box>

      <CRFBasePopup
        selectedCRFFormCode={selectedFormOID}
        crfFormMetaData={crfFormMetaData}
        parent_id={parent_id}
        isUpdate={isUpdate}
        setisUpdate={setisUpdate}
        selectedVisit={selectedVisit}
        visitsData={getPatientsDetailsData}
        editRowData={editRowData}
        setselectedVisit={setselectedVisit}
        seteditRowData={seteditRowData}
        bookMarkKey={bookMarkKey}
        bookMarkField={bookMarkField}
        isAddCliked={isAddCliked}
        setisAddCliked={setisAddCliked}
        isAddMode={isAddMode}
        individualEventData={selectCRFDataByIDData}
        setcrfFormMetaData={setcrfFormMetaData}
        loading={isLoading}
        selectedAppointment={selectedAppointment}
      />
      <PopupComponent
        open={openDeleteCRFModel}
        // onClose={handleCloseDeleteCRFModel}
        aria-labelledby="Remove CRF Modal"
        aria-describedby=""
      >
        <DialogTitle id="alert-dialog-title">Delete Event?</DialogTitle>
        <DialogContent>
          <Typography gutterBottom>
            Are you sure to delete the event? If there are any linked CRF(s), it`s link also will get deleted.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteCRFModel} className="grey-btn">
            NO
          </Button>
          <Button onClick={handleConfirmDeleteCRFModel} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </PopupComponent>

      <PopupComponent maxWidth="md" open={openAuditTrailCRF}>
        <AuditTrailContent
          handleCloseAudit={handleCloseAuditTrailCRF}
          auditUsersList={auditUsersList}
          audit_module_section={`PATIENT TRIAL NOTEBOOK`}
          id={selectedCRFData?.event_uuid}
          AdvancedFilterArray={staticData.AdvancedQueryFilter}
          isCRFForm
          formDetails={crfFormMetaData?.meta}
        />
      </PopupComponent>
    </div>
  );
};
export default CRFSTab;
